export const showPrizeTabContent = () => {
  const dreamCarITH = document.querySelector(".dreamCarITH") as HTMLElement;
  if (dreamCarITH) {
    dreamCarITH.style.display = "block";
  }
  const dreamCarFiltersAndPrizes = document.querySelector(".dreamCarFiltersAndPrizes") as HTMLElement;
  if (dreamCarFiltersAndPrizes) {
    dreamCarFiltersAndPrizes.style.display = "block";
  }
  const backToTopContainer = document.querySelector(".backToTop")?.parentElement?.parentElement
    ?.parentElement as HTMLElement;
  if (backToTopContainer) {
    backToTopContainer.style.display = "block";
  }
  const carsIcons = document.querySelector(".cars-icons") as HTMLElement;
  if (carsIcons) {
    carsIcons.style.display = "block";
  }
  const instantWinPrizes = document.querySelector(".instantWinPrizes") as HTMLElement;
  if (instantWinPrizes) {
    instantWinPrizes.style.display = "none";
  }
  const instantWinInfo = document.querySelector(".instant-win-info.tabbed") as HTMLElement;
  if (instantWinInfo) {
    instantWinInfo.style.display = "none";
  }
};

export const showInstantWinTabContent = () => {
  const dreamCarITH = document.querySelector(".dreamCarITH") as HTMLElement;
  if (dreamCarITH) {
    dreamCarITH.style.display = "none";
  }
  const dreamCarFiltersAndPrizes = document.querySelector(".dreamCarFiltersAndPrizes") as HTMLElement;
  if (dreamCarFiltersAndPrizes) {
    dreamCarFiltersAndPrizes.style.display = "none";
  }
  const backToTopContainer = document.querySelector(".backToTop")?.parentElement?.parentElement
    ?.parentElement as HTMLElement;
  if (backToTopContainer) {
    backToTopContainer.style.display = "none";
  }
  const carsIcons = document.querySelector(".cars-icons") as HTMLElement;
  if (carsIcons) {
    carsIcons.style.display = "none";
  }
  const instantWinPrizes = document.querySelector(".instantWinPrizes") as HTMLElement;
  if (instantWinPrizes) {
    instantWinPrizes.style.display = "block";
  }
  const instantWinInfo = document.querySelector(".instant-win-info.tabbed") as HTMLElement;
  if (instantWinInfo) {
    instantWinInfo.style.display = "block";
  }
};
